// Notes.jsx
import React, { useMemo, useState } from 'react';
import Classes from './Notes.module.css';
import MessageItem from './MessageItem';
import backend from '../../../../../../../../../api';

export default function Notes({ loading, userId, notes = [] }) {
  const [items, setItems] = useState(notes);
  const [text, setText] = useState("");
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState("");

  // keep local state in sync if parent refreshes
  React.useEffect(() => { setItems(notes); }, [notes]);

  const handleAdd = async () => {
    if (!text.trim() || !userId) return;
    setSaving(true); setErr("");
    try {
      const { data } = await backend.post(`/api/user/${userId}/notes`, {
        text,
        // byUserId: <currentAdminId>  // if you have it; otherwise backend keeps null
      });
      setItems(data?.notes || []);
      setText("");
    } catch (e) {
      setErr(e?.response?.data?.error || e.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className={Classes.main}>
      <div className={Classes.left}>
        <div className={`${Classes.messages} scroll`}>
          {loading ? (
            <div style={{ padding: 12, color: '#888' }}>Loading…</div>
          ) : (items || []).length ? (
            items
              .slice()                    // newest last or first—your choice
              .sort((a, b) => new Date(b.at) - new Date(a.at))
              .map((n, idx) => (
                <MessageItem
                  key={n._id || idx}
                  index={idx}
                  name={n?.by?.name || [n?.by?.firstName, n?.by?.lastName].filter(Boolean).join(" ") || "System"}
                  role={"Note"}
                  time={new Date(n.at).toLocaleString()}
                  message={n.text}
                />
              ))
          ) : (
            <h5 className='placeholderText' >No notes yet.</h5>
          )}
        </div>

        <div style={{ position: 'relative' }}>
          <div className={Classes.whiteFade}></div>
        </div>

        <div className={Classes.commentBox}>
          <input
            type="text"
            placeholder="Add a note"
            value={text}
            onChange={(e) => setText(e.target.value)}
            disabled={saving || loading}
          />
          <button onClick={handleAdd} disabled={saving || loading || !text.trim()}>
            <svg xmlns="http://www.w3.org/2000/svg" fill="rgba(223, 135, 91, 1)" height='17px' viewBox="0 0 512 512"><path d="M498.1 5.6c10.1 7 15.4 19.1 13.5 31.2l-64 416c-1.5 9.7-7.4 18.2-16 23s-18.9 5.4-28 1.6L284 427.7l-68.5 74.1c-8.9 9.7-22.9 12.9-35.2 8.1S160 493.2 160 480l0-83.6c0-4 1.5-7.8 4.2-10.8L331.8 202.8c5.8-6.3 5.6-16-.4-22s-15.7-6.4-22-.7L106 360.8 17.7 316.6C7.1 311.3 .3 300.7 0 288.9s5.9-22.8 16.1-28.7l448-256c10.7-6.1 23.9-5.5 34 1.4z" /></svg>
          </button>
        </div>

        {err && <div style={{ color: 'crimson', marginTop: 6 }}>{err}</div>}
      </div>
    </div>
  );
}
